import { RaidPlanOwner } from './raid_plans'
import RaidPlan, { RaidPlanTimeline } from 'app/frontend/types/custom/RaidPlan'
import VisualPlan, { VisualScreen } from 'app/frontend/types/custom/VisualPlan'
import { getRequest, postRequest } from '.'

export type PlanKind = 'raid' | 'visual'

export type PlanVersionAuthor = {
  id: number
  label?: string | null
}

export type PlanVersionMetadata = {
  actorCount?: number
  castCount?: number
  assignmentCount?: number
  screenCount?: number
  objectCount?: number
}

export type RaidPlanVersionData = {
  timeline: RaidPlanTimeline
  message?: string | null
  include_message_in_export?: boolean
}

export type VisualPlanVersionData = {
  screens: VisualScreen[]
}

export type PlanVersionData = RaidPlanVersionData | VisualPlanVersionData

export type PlanVersionSummary = {
  id: number
  createdAt: string
  name?: string | null
  metadata: PlanVersionMetadata
  authors: PlanVersionAuthor[]
}

export type PlanVersionDetail = PlanVersionSummary & {
  data: PlanVersionData
}

export type PlanVersionsResponse = {
  pendingAuthors: PlanVersionAuthor[]
  versions: PlanVersionSummary[]
}

const versionsPath = (kind: PlanKind, owner: RaidPlanOwner, planId: number) => {
  const resource = kind === 'raid' ? 'raid_plans' : 'visual_plans'
  const base =
    owner.ownerType === 'team'
      ? `/api/teams/${owner.ownerId}/${resource}`
      : `/api/user/${resource}`
  return `${base}/${planId}/versions`
}

export const getPlanVersions = async (
  kind: PlanKind,
  owner: RaidPlanOwner,
  planId: number,
): Promise<PlanVersionsResponse> => {
  return await getRequest(versionsPath(kind, owner, planId))
}

export const getPlanVersion = async (
  kind: PlanKind,
  owner: RaidPlanOwner,
  planId: number,
  versionId: number,
): Promise<PlanVersionDetail> => {
  return await getRequest(`${versionsPath(kind, owner, planId)}/${versionId}`)
}

export const restorePlanVersion = async (
  kind: PlanKind,
  owner: RaidPlanOwner,
  planId: number,
  versionId: number,
): Promise<RaidPlan | VisualPlan> => {
  return await postRequest(
    `${versionsPath(kind, owner, planId)}/${versionId}/restore`,
  )
}
